import * as yup from 'yup';

export const strictMailSchema = yup.object().shape({
	mailTo: yup
		.array()
		.of(
			yup
				.string()
				.matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'error.mailError'),
		)
		.required('error.required'),
	mailCC: yup
		.array()
		.of(
			yup
				.string()
				.matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'error.mailError'),
		)
		.optional(),
});

export const nonStrictMailSchema = yup.object().shape({
	mailTo: yup.array().of(yup.string()).optional(),
	mailCC: yup.array().of(yup.string()).optional(),
});
